import { useAuth } from '#auth/AuthProvider';
import { Permissions } from '#auth/types';
import { useMultiuserEnabled, useServerURL } from '#components/ServerContext';
import { useMetadataPref } from '#hooks/useMetadataPref';
import { useSelector } from '#redux';

/**
 * Si este presupuesto lo compartieron contigo para solo ver, o si puedes
 * compartirlo tú (eres su dueño o el administrador). Lo usan este apartado y
 * la lista de Ajustes, para no enseñar la fila «Compartir» vacía. `aBordo`:
 * vas en la tripulación de un presupuesto que no es tuyo (puedes bajarte).
 */
export function useCompartir() {
  const multiuserEnabled = useMultiuserEnabled();
  const serverURL = useServerURL();
  const [cloudFileId] = useMetadataPref('cloudFileId');
  const userData = useSelector(state => state.user.data);
  const allFiles = useSelector(state => state.budgetfiles.allFiles || []);
  const { hasPermission } = useAuth();
  const [soloLectura] = useMetadataPref('rumboSoloLectura');

  const archivo = allFiles.find(
    f => 'cloudFileId' in f && f.cloudFileId === cloudFileId,
  );
  const esDueno =
    archivo && 'owner' in archivo && userData?.userId === archivo.owner;
  const puedeCompartir = Boolean(
    multiuserEnabled &&
    serverURL &&
    cloudFileId &&
    !userData?.offline &&
    (esDueno || hasPermission(Permissions.ADMINISTRATOR)),
  );
  const aBordo = Boolean(
    !esDueno &&
    archivo &&
    'usersWithAccess' in archivo &&
    archivo.usersWithAccess.some(
      u => !u.owner && u.userId === userData?.userId,
    ),
  );
  return {
    aBordo,
    soloLectura: Boolean(soloLectura),
    puedeCompartir,
    cloudFileId,
  };
}
